window.clickOnlyStepFunction = function(t) {
    $(t).find("a").trigger("click");
};

window.clickStepFunction = function(t) {
    window.location.href = t.attr("href");
};


(function() {
    $(window).on('load trigger_iguider',function() {
        console.log('iguider looking for window steps')
        if (typeof window.steps !== "undefined") {
            console.log('iguider found window steps');
            var opts = { 
                'tourTitle': 'HQ iKnowAuto:  Parts',
                'steps': window.steps,
                'intro': {
                    enable: false,
                }
            };
            iGuider('destroy');
            iGuider('button', opts);
        }
    });
})();
